<template>
  <div>
    <section-definition
      :title="page.title"
      :breadcrumbs="breadcrumbs"
    ></section-definition>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar.."
          single-line
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="tickets2"
        :search="search"
        :loading="isLoading"
        rows-per-page-text="Filas por página"
        :rows-per-page-items="[15, 30, 50, { text: 'todas', value: -1 }]"
        class="elevation-1 fixed-header"
        dense
      >
        <v-progress-linear
          slot="progress"
          color="yellow"
          indeterminate
        ></v-progress-linear>

        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.tickettype }}</td>
          <td class="text-xs-center">{{ props.item.creatoralias }}</td>
          <td class="text-xs-center">{{ props.item.ticketcreationdate }}</td>
          <td :class="props.item.statusclass">{{ props.item.statuslabel }}</td>
          <td class="text-xs-center">{{ props.item.ticketname }}</td>
          <td class="text-xs-center">{{ props.item.ticketdescription }}</td>
          <td class="text-xs-center">{{ props.item.id }}</td>
          <td class="text-xs-center">{{ props.item.ticketresponsedate }}</td>
          <td>
            <v-icon class="mr-2" @click="gotoDetail(props.item.id)">
              visibility
            </v-icon>
          </td>
        </template>
        <template slot="pageText" slot-scope="props">
          Filas {{ props.pageStart }} - {{ props.pageStop }} de
          {{ props.itemsLength }}
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          La búsqueda de "{{ search }}" no ha encontrado resultados.
        </v-alert>
      </v-data-table>
    </v-card>

    <v-snackbar
      v-model="snackresult"
      :color="snackcolor"
      :timeout="6000"
      top="true"
    >
      {{ snacktext }}
      <v-btn dark flat @click="snackresult = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
//import moment from "moment";

export default {
  name: "app",
  data() {
    return {
      chatMessageEditor: null,
      search: "",
      tickets: [],
      messages: [],
      newReptile: "",
      currentGroup: {},
      title: "Contactos",

      backgroundImg: "/static/doc-images/HexesisMaterial03.png",
      activeGroupId: 1,
      curreentAvatar: "",
      ownerAvatar: "",
      ownerUuid: "",
      currentChatroom: "",
      owneralias: "",
      headers: [
        { text: "Tipo", value: "tickettype" },
        { text: "Creado por", value: "creatoralias" },
        { text: "Fecha", value: "ticketcreationdate" },
        { text: "Estado ", value: "machinedescription" },
        { text: "Asunto", value: "machineprice" },
        { text: "Descripcion", value: "machinepminrice" },
        { text: "TicketID", value: "id" },
         { text: "Fecha respuesta", value: "ticketresponsedate" },
       { text: "Acciones ", value: "" }
      ],
      page: {
        title: "Incidencias",
        headline: "Lista de equipos",
        description: "Equipos activos"
      }
    };
  },
  firestore() {
    return {
      tickets: [] // db.collection( "contacts").orderBy("id")
    };
  },
  mounted: function() {
    console.log("nnn");
     //this.chats = db.collection("users/"+ this.ownerUuid+"/userrooms")
  },
  components: {},
  computed: {

  },
  methods: {

            
    gotoDetail(uuid){

        this.$router.push({
          name: "pages/TicketManagePage",
          params: {
            currentticket: uuid
            }
        });

        },    
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.reptileList {
  list-style: none;
}
.toobar-extension {
  margin-left: 0 !important;
  min-width: 300px;
}
.state1 {
  background-color: salmon;
  color: #ffffff;
}

.state2 {
  background-color: green;
  color: #ffffff;
}

.state3 {
  background-color: red;
  color: #ffffff;
  
}
</style>
